// セッション・メッセージは oRPC 管理（`orpc.aiOperatorChat.*.key()`）のため、
// ここに手動キーは持たない。モデル一覧のみ FE モックなので独自キーを定義する。
export const globalAiChatQueryKey = {
  all: ['global-ai-chat'] as const,
  models: () => [...globalAiChatQueryKey.all, 'models'] as const,
};
